"use strict";
// Alternative to Util.FullDateStr usage of template literals
// Not as type-strict, but avoids too many unions compilation error
Object.defineProperty(exports, "__esModule", { value: true });
exports.SftpConfigSchema = exports.EncryptionConfigSchema = exports.EncryptionTypeSchema = exports.FrequencyType = exports.FrequencyPeriodIterable = exports.FrequencyPeriod = exports.DateTimeZones = exports.SqlPrimitiveStruct = exports.TextFormatEnum = exports.PercentageFormatEnum = exports.CurrencyFormatEnum = exports.DateFormatEnum = exports.FormatTypeEnum = exports.SupportedFileExtensionSchema = exports.SupportedFileExtensionIterable = exports.OutputReportFileExtensionIterable = exports.ZodFullDateStrForJsonSchemaStruct = exports.ZodFullDateStrLightWeightStruct = exports.ZodFullDateStrStruct = void 0;
const zod_1 = require("zod");
const ZodPaddedNumber = zod_1.z.templateLiteral([
    zod_1.z.union([zod_1.z.literal('0'), zod_1.z.literal('')]),
    zod_1.z.number(),
]);
exports.ZodFullDateStrStruct = zod_1.z
    .templateLiteral([zod_1.z.number(), '-', ZodPaddedNumber, '-', ZodPaddedNumber])
    .refine((val) => /^\d{4}-\d{2}-\d{2}$/.test(val), {
    error: 'Invalid date format, must be YYYY-MM-DD',
})
    .refine((date) => {
    const [year, month, day] = date.split('-').map(Number);
    const dateObj = new Date(year, month - 1, day);
    return (dateObj.getFullYear() === year &&
        dateObj.getMonth() + 1 === month &&
        dateObj.getDate() === day);
}, { error: 'Invalid date value' });
// when possible, use ZodFullDateStrStruct, as it contains a richer validation of FullDateStr
// however, it does not codegen well into our static jsonschema files that the CA currently uses
// this lightweight struct serves as zod replacement to our existing FullDateStr, until we can entirely
// move away from codegen jsonschema file\
// ideally this is only needed temporarily as we transition the CA to zod schema.
exports.ZodFullDateStrLightWeightStruct = zod_1.z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/, 'Invalid date format, must be YYYY-MM-DD');
/**
 * A Zod schema that maintains the FullDateStr type for TypeScript compatibility
 * but generates proper JSON schemas (solution to ZodFullDateStrStruct).
 * This is the recommended struct for types that need JSON schema generation.
 *
 * Uses the lightweight regex pattern that generates proper JSON schema,
 * but extends it with the FullDateStr type for TypeScript compatibility.
 */
exports.ZodFullDateStrForJsonSchemaStruct = zod_1.z.custom((val) => {
    if (typeof val !== 'string')
        return false;
    if (!/^\d{4}-\d{2}-\d{2}$/.test(val))
        return false;
    // Runtime validation same as ZodFullDateStrStruct
    const [year, month, day] = val.split('-').map(Number);
    const dateObj = new Date(year, month - 1, day);
    return (dateObj.getFullYear() === year &&
        dateObj.getMonth() + 1 === month &&
        dateObj.getDate() === day);
}, { message: 'Invalid date format, must be YYYY-MM-DD' });
exports.OutputReportFileExtensionIterable = [
    'csv',
    'xlsx',
    'xlsb',
    'xlsm',
    'json',
    'docx',
    'pdf',
    'png',
    'txt',
    'zip',
];
exports.SupportedFileExtensionIterable = [
    'csv',
    'json',
    'xls',
    'xlsx',
    'XLSX',
    'xlsb',
    'xlsm',
    'pdf',
    'txt',
    'zip',
    'html',
    'tif',
    'tiff',
    'jpeg',
    'jpg',
    'png',
    'gz',
    'pgp',
    'gpg',
];
exports.SupportedFileExtensionSchema = zod_1.z.enum(exports.SupportedFileExtensionIterable);
var FormatTypeEnum;
(function (FormatTypeEnum) {
    FormatTypeEnum["currency"] = "currency";
    FormatTypeEnum["percentage"] = "percentage";
    FormatTypeEnum["date"] = "date";
    FormatTypeEnum["text"] = "text";
})(FormatTypeEnum || (exports.FormatTypeEnum = FormatTypeEnum = {}));
// TODO: do we really need to limit to certain formats
// can we check these more dynamically?
var DateFormatEnum;
(function (DateFormatEnum) {
    DateFormatEnum["L/d/yy"] = "L/d/yy";
    DateFormatEnum["LL/dd/yyyy"] = "LL/dd/yyyy";
    DateFormatEnum["LL/dd/yy"] = "LL/dd/yy";
    DateFormatEnum["L/d/yyyy"] = "L/d/yyyy";
    DateFormatEnum["L-d-yyyy"] = "L-d-yyyy";
    DateFormatEnum["L-d-yy"] = "L-d-yy";
    DateFormatEnum["L-dd-yy"] = "L-dd-yy";
    DateFormatEnum["L-dd-yyyy"] = "L-dd-yyyy";
    DateFormatEnum["L/dd/yyyy"] = "L/dd/yyyy";
    DateFormatEnum["L/dd/yy"] = "L/dd/yy";
    DateFormatEnum["LL-dd-yyyy"] = "LL-dd-yyyy";
    DateFormatEnum["LLL dd, yyyy"] = "LLL dd, yyyy";
    DateFormatEnum["LLLL d yyyy"] = "LLLL d yyyy";
    DateFormatEnum["LLLL d, yyyy"] = "LLLL d, yyyy";
    DateFormatEnum["dd LLLL, yyyy"] = "dd LLLL, yyyy";
    DateFormatEnum["yyyy-L-dd"] = "yyyy-L-dd";
    DateFormatEnum["yyyy-LL-dd"] = "yyyy-LL-dd";
    DateFormatEnum["YYYY/LL/DD"] = "YYYY/LL/DD";
    DateFormatEnum["M/d/y hh:mm:ss a"] = "M/d/y hh:mm:ss a";
})(DateFormatEnum || (exports.DateFormatEnum = DateFormatEnum = {}));
var CurrencyFormatEnum;
(function (CurrencyFormatEnum) {
    CurrencyFormatEnum["thousandsWithCommasAndDecimalCents"] = "thousandsWithCommasAndDecimalCents";
    CurrencyFormatEnum["decimalCents"] = "decimalCents";
    CurrencyFormatEnum["thousandsCommas"] = "thousandsCommas";
    CurrencyFormatEnum["thousandsWithCommasAndDecimalCentsAndSymbol"] = "thousandsWithCommasAndDecimalCentsAndSymbol";
})(CurrencyFormatEnum || (exports.CurrencyFormatEnum = CurrencyFormatEnum = {}));
var PercentageFormatEnum;
(function (PercentageFormatEnum) {
    PercentageFormatEnum["rawDecimal"] = "rawDecimal";
    PercentageFormatEnum["formattedPercentage"] = "formattedPercentage";
})(PercentageFormatEnum || (exports.PercentageFormatEnum = PercentageFormatEnum = {}));
var TextFormatEnum;
(function (TextFormatEnum) {
    TextFormatEnum["lowerCase"] = "lowerCase";
    TextFormatEnum["allCaps"] = "allCaps";
    TextFormatEnum["sentenceCase"] = "sentenceCase";
    TextFormatEnum["titleCase"] = "titleCase";
    TextFormatEnum["none"] = "none";
})(TextFormatEnum || (exports.TextFormatEnum = TextFormatEnum = {}));
exports.SqlPrimitiveStruct = zod_1.z.union([
    zod_1.z.string(),
    zod_1.z.number(),
    zod_1.z.boolean(),
    zod_1.z.null(),
]);
// IANA time zones: https://stackoverflow.com/questions/38399465/how-to-get-list-of-all-timezones-in-javascript
var DateTimeZones;
(function (DateTimeZones) {
    DateTimeZones["Europe/Andorra"] = "Europe/Andorra";
    DateTimeZones["Asia/Dubai"] = "Asia/Dubai";
    DateTimeZones["Asia/Kabul"] = "Asia/Kabul";
    DateTimeZones["Europe/Tirane"] = "Europe/Tirane";
    DateTimeZones["Asia/Yerevan"] = "Asia/Yerevan";
    DateTimeZones["Antarctica/Casey"] = "Antarctica/Casey";
    DateTimeZones["Antarctica/Davis"] = "Antarctica/Davis";
    DateTimeZones["Antarctica/DumontDUrville"] = "Antarctica/DumontDUrville";
    DateTimeZones["Antarctica/Mawson"] = "Antarctica/Mawson";
    DateTimeZones["Antarctica/Palmer"] = "Antarctica/Palmer";
    DateTimeZones["Antarctica/Rothera"] = "Antarctica/Rothera";
    DateTimeZones["Antarctica/Syowa"] = "Antarctica/Syowa";
    DateTimeZones["Antarctica/Troll"] = "Antarctica/Troll";
    DateTimeZones["Antarctica/Vostok"] = "Antarctica/Vostok";
    DateTimeZones["America/Argentina/Buenos_Aires"] = "America/Argentina/Buenos_Aires";
    DateTimeZones["America/Argentina/Cordoba"] = "America/Argentina/Cordoba";
    DateTimeZones["America/Argentina/Salta"] = "America/Argentina/Salta";
    DateTimeZones["America/Argentina/Jujuy"] = "America/Argentina/Jujuy";
    DateTimeZones["America/Argentina/Tucuman"] = "America/Argentina/Tucuman";
    DateTimeZones["America/Argentina/Catamarca"] = "America/Argentina/Catamarca";
    DateTimeZones["America/Argentina/La_Rioja"] = "America/Argentina/La_Rioja";
    DateTimeZones["America/Argentina/San_Juan"] = "America/Argentina/San_Juan";
    DateTimeZones["America/Argentina/Mendoza"] = "America/Argentina/Mendoza";
    DateTimeZones["America/Argentina/San_Luis"] = "America/Argentina/San_Luis";
    DateTimeZones["America/Argentina/Rio_Gallegos"] = "America/Argentina/Rio_Gallegos";
    DateTimeZones["America/Argentina/Ushuaia"] = "America/Argentina/Ushuaia";
    DateTimeZones["Pacific/Pago_Pago"] = "Pacific/Pago_Pago";
    DateTimeZones["Europe/Vienna"] = "Europe/Vienna";
    DateTimeZones["Australia/Lord_Howe"] = "Australia/Lord_Howe";
    DateTimeZones["Antarctica/Macquarie"] = "Antarctica/Macquarie";
    DateTimeZones["Australia/Hobart"] = "Australia/Hobart";
    DateTimeZones["Australia/Currie"] = "Australia/Currie";
    DateTimeZones["Australia/Melbourne"] = "Australia/Melbourne";
    DateTimeZones["Australia/Sydney"] = "Australia/Sydney";
    DateTimeZones["Australia/Broken_Hill"] = "Australia/Broken_Hill";
    DateTimeZones["Australia/Brisbane"] = "Australia/Brisbane";
    DateTimeZones["Australia/Lindeman"] = "Australia/Lindeman";
    DateTimeZones["Australia/Adelaide"] = "Australia/Adelaide";
    DateTimeZones["Australia/Darwin"] = "Australia/Darwin";
    DateTimeZones["Australia/Perth"] = "Australia/Perth";
    DateTimeZones["Australia/Eucla"] = "Australia/Eucla";
    DateTimeZones["Asia/Baku"] = "Asia/Baku";
    DateTimeZones["America/Barbados"] = "America/Barbados";
    DateTimeZones["Asia/Dhaka"] = "Asia/Dhaka";
    DateTimeZones["Europe/Brussels"] = "Europe/Brussels";
    DateTimeZones["Europe/Sofia"] = "Europe/Sofia";
    DateTimeZones["Atlantic/Bermuda"] = "Atlantic/Bermuda";
    DateTimeZones["Asia/Brunei"] = "Asia/Brunei";
    DateTimeZones["America/La_Paz"] = "America/La_Paz";
    DateTimeZones["America/Noronha"] = "America/Noronha";
    DateTimeZones["America/Belem"] = "America/Belem";
    DateTimeZones["America/Fortaleza"] = "America/Fortaleza";
    DateTimeZones["America/Recife"] = "America/Recife";
    DateTimeZones["America/Araguaina"] = "America/Araguaina";
    DateTimeZones["America/Maceio"] = "America/Maceio";
    DateTimeZones["America/Bahia"] = "America/Bahia";
    DateTimeZones["America/Sao_Paulo"] = "America/Sao_Paulo";
    DateTimeZones["America/Campo_Grande"] = "America/Campo_Grande";
    DateTimeZones["America/Cuiaba"] = "America/Cuiaba";
    DateTimeZones["America/Santarem"] = "America/Santarem";
    DateTimeZones["America/Porto_Velho"] = "America/Porto_Velho";
    DateTimeZones["America/Boa_Vista"] = "America/Boa_Vista";
    DateTimeZones["America/Manaus"] = "America/Manaus";
    DateTimeZones["America/Eirunepe"] = "America/Eirunepe";
    DateTimeZones["America/Rio_Branco"] = "America/Rio_Branco";
    DateTimeZones["America/Nassau"] = "America/Nassau";
    DateTimeZones["Asia/Thimphu"] = "Asia/Thimphu";
    DateTimeZones["Europe/Minsk"] = "Europe/Minsk";
    DateTimeZones["America/Belize"] = "America/Belize";
    DateTimeZones["America/St_Johns"] = "America/St_Johns";
    DateTimeZones["America/Halifax"] = "America/Halifax";
    DateTimeZones["America/Glace_Bay"] = "America/Glace_Bay";
    DateTimeZones["America/Moncton"] = "America/Moncton";
    DateTimeZones["America/Goose_Bay"] = "America/Goose_Bay";
    DateTimeZones["America/Blanc-Sablon"] = "America/Blanc-Sablon";
    DateTimeZones["America/Toronto"] = "America/Toronto";
    DateTimeZones["America/Nipigon"] = "America/Nipigon";
    DateTimeZones["America/Thunder_Bay"] = "America/Thunder_Bay";
    DateTimeZones["America/Iqaluit"] = "America/Iqaluit";
    DateTimeZones["America/Pangnirtung"] = "America/Pangnirtung";
    DateTimeZones["America/Atikokan"] = "America/Atikokan";
    DateTimeZones["America/Winnipeg"] = "America/Winnipeg";
    DateTimeZones["America/Rainy_River"] = "America/Rainy_River";
    DateTimeZones["America/Resolute"] = "America/Resolute";
    DateTimeZones["America/Rankin_Inlet"] = "America/Rankin_Inlet";
    DateTimeZones["America/Regina"] = "America/Regina";
    DateTimeZones["America/Swift_Current"] = "America/Swift_Current";
    DateTimeZones["America/Edmonton"] = "America/Edmonton";
    DateTimeZones["America/Cambridge_Bay"] = "America/Cambridge_Bay";
    DateTimeZones["America/Yellowknife"] = "America/Yellowknife";
    DateTimeZones["America/Inuvik"] = "America/Inuvik";
    DateTimeZones["America/Creston"] = "America/Creston";
    DateTimeZones["America/Dawson_Creek"] = "America/Dawson_Creek";
    DateTimeZones["America/Fort_Nelson"] = "America/Fort_Nelson";
    DateTimeZones["America/Vancouver"] = "America/Vancouver";
    DateTimeZones["America/Whitehorse"] = "America/Whitehorse";
    DateTimeZones["America/Dawson"] = "America/Dawson";
    DateTimeZones["Indian/Cocos"] = "Indian/Cocos";
    DateTimeZones["Europe/Zurich"] = "Europe/Zurich";
    DateTimeZones["Africa/Abidjan"] = "Africa/Abidjan";
    DateTimeZones["Pacific/Rarotonga"] = "Pacific/Rarotonga";
    DateTimeZones["America/Santiago"] = "America/Santiago";
    DateTimeZones["America/Punta_Arenas"] = "America/Punta_Arenas";
    DateTimeZones["Pacific/Easter"] = "Pacific/Easter";
    DateTimeZones["Asia/Shanghai"] = "Asia/Shanghai";
    DateTimeZones["Asia/Urumqi"] = "Asia/Urumqi";
    DateTimeZones["America/Bogota"] = "America/Bogota";
    DateTimeZones["America/Costa_Rica"] = "America/Costa_Rica";
    DateTimeZones["America/Havana"] = "America/Havana";
    DateTimeZones["Atlantic/Cape_Verde"] = "Atlantic/Cape_Verde";
    DateTimeZones["America/Curacao"] = "America/Curacao";
    DateTimeZones["Indian/Christmas"] = "Indian/Christmas";
    DateTimeZones["Asia/Nicosia"] = "Asia/Nicosia";
    DateTimeZones["Asia/Famagusta"] = "Asia/Famagusta";
    DateTimeZones["Europe/Prague"] = "Europe/Prague";
    DateTimeZones["Europe/Berlin"] = "Europe/Berlin";
    DateTimeZones["Europe/Copenhagen"] = "Europe/Copenhagen";
    DateTimeZones["America/Santo_Domingo"] = "America/Santo_Domingo";
    DateTimeZones["Africa/Algiers"] = "Africa/Algiers";
    DateTimeZones["America/Guayaquil"] = "America/Guayaquil";
    DateTimeZones["Pacific/Galapagos"] = "Pacific/Galapagos";
    DateTimeZones["Europe/Tallinn"] = "Europe/Tallinn";
    DateTimeZones["Africa/Cairo"] = "Africa/Cairo";
    DateTimeZones["Africa/El_Aaiun"] = "Africa/El_Aaiun";
    DateTimeZones["Europe/Madrid"] = "Europe/Madrid";
    DateTimeZones["Africa/Ceuta"] = "Africa/Ceuta";
    DateTimeZones["Atlantic/Canary"] = "Atlantic/Canary";
    DateTimeZones["Europe/Helsinki"] = "Europe/Helsinki";
    DateTimeZones["Pacific/Fiji"] = "Pacific/Fiji";
    DateTimeZones["Atlantic/Stanley"] = "Atlantic/Stanley";
    DateTimeZones["Pacific/Chuuk"] = "Pacific/Chuuk";
    DateTimeZones["Pacific/Pohnpei"] = "Pacific/Pohnpei";
    DateTimeZones["Pacific/Kosrae"] = "Pacific/Kosrae";
    DateTimeZones["Atlantic/Faroe"] = "Atlantic/Faroe";
    DateTimeZones["Europe/Paris"] = "Europe/Paris";
    DateTimeZones["Europe/London"] = "Europe/London";
    DateTimeZones["Asia/Tbilisi"] = "Asia/Tbilisi";
    DateTimeZones["America/Cayenne"] = "America/Cayenne";
    DateTimeZones["Africa/Accra"] = "Africa/Accra";
    DateTimeZones["Europe/Gibraltar"] = "Europe/Gibraltar";
    DateTimeZones["America/Godthab"] = "America/Godthab";
    DateTimeZones["America/Danmarkshavn"] = "America/Danmarkshavn";
    DateTimeZones["America/Scoresbysund"] = "America/Scoresbysund";
    DateTimeZones["America/Thule"] = "America/Thule";
    DateTimeZones["Europe/Athens"] = "Europe/Athens";
    DateTimeZones["Atlantic/South_Georgia"] = "Atlantic/South_Georgia";
    DateTimeZones["America/Guatemala"] = "America/Guatemala";
    DateTimeZones["Pacific/Guam"] = "Pacific/Guam";
    DateTimeZones["Africa/Bissau"] = "Africa/Bissau";
    DateTimeZones["America/Guyana"] = "America/Guyana";
    DateTimeZones["Asia/Hong_Kong"] = "Asia/Hong_Kong";
    DateTimeZones["America/Tegucigalpa"] = "America/Tegucigalpa";
    DateTimeZones["America/Port-au-Prince"] = "America/Port-au-Prince";
    DateTimeZones["Europe/Budapest"] = "Europe/Budapest";
    DateTimeZones["Asia/Jakarta"] = "Asia/Jakarta";
    DateTimeZones["Asia/Pontianak"] = "Asia/Pontianak";
    DateTimeZones["Asia/Makassar"] = "Asia/Makassar";
    DateTimeZones["Asia/Jayapura"] = "Asia/Jayapura";
    DateTimeZones["Europe/Dublin"] = "Europe/Dublin";
    DateTimeZones["Asia/Jerusalem"] = "Asia/Jerusalem";
    DateTimeZones["Asia/Kolkata"] = "Asia/Kolkata";
    DateTimeZones["Indian/Chagos"] = "Indian/Chagos";
    DateTimeZones["Asia/Baghdad"] = "Asia/Baghdad";
    DateTimeZones["Asia/Tehran"] = "Asia/Tehran";
    DateTimeZones["Atlantic/Reykjavik"] = "Atlantic/Reykjavik";
    DateTimeZones["Europe/Rome"] = "Europe/Rome";
    DateTimeZones["America/Jamaica"] = "America/Jamaica";
    DateTimeZones["Asia/Amman"] = "Asia/Amman";
    DateTimeZones["Asia/Tokyo"] = "Asia/Tokyo";
    DateTimeZones["Africa/Nairobi"] = "Africa/Nairobi";
    DateTimeZones["Asia/Bishkek"] = "Asia/Bishkek";
    DateTimeZones["Pacific/Tarawa"] = "Pacific/Tarawa";
    DateTimeZones["Pacific/Enderbury"] = "Pacific/Enderbury";
    DateTimeZones["Pacific/Kiritimati"] = "Pacific/Kiritimati";
    DateTimeZones["Asia/Pyongyang"] = "Asia/Pyongyang";
    DateTimeZones["Asia/Seoul"] = "Asia/Seoul";
    DateTimeZones["Asia/Almaty"] = "Asia/Almaty";
    DateTimeZones["Asia/Qyzylorda"] = "Asia/Qyzylorda";
    DateTimeZones["Asia/Qostanay"] = "Asia/Qostanay";
    DateTimeZones["Asia/Aqtobe"] = "Asia/Aqtobe";
    DateTimeZones["Asia/Aqtau"] = "Asia/Aqtau";
    DateTimeZones["Asia/Atyrau"] = "Asia/Atyrau";
    DateTimeZones["Asia/Oral"] = "Asia/Oral";
    DateTimeZones["Asia/Beirut"] = "Asia/Beirut";
    DateTimeZones["Asia/Colombo"] = "Asia/Colombo";
    DateTimeZones["Africa/Monrovia"] = "Africa/Monrovia";
    DateTimeZones["Europe/Vilnius"] = "Europe/Vilnius";
    DateTimeZones["Europe/Luxembourg"] = "Europe/Luxembourg";
    DateTimeZones["Europe/Riga"] = "Europe/Riga";
    DateTimeZones["Africa/Tripoli"] = "Africa/Tripoli";
    DateTimeZones["Africa/Casablanca"] = "Africa/Casablanca";
    DateTimeZones["Europe/Monaco"] = "Europe/Monaco";
    DateTimeZones["Europe/Chisinau"] = "Europe/Chisinau";
    DateTimeZones["Pacific/Majuro"] = "Pacific/Majuro";
    DateTimeZones["Pacific/Kwajalein"] = "Pacific/Kwajalein";
    DateTimeZones["Asia/Yangon"] = "Asia/Yangon";
    DateTimeZones["Asia/Ulaanbaatar"] = "Asia/Ulaanbaatar";
    DateTimeZones["Asia/Hovd"] = "Asia/Hovd";
    DateTimeZones["Asia/Choibalsan"] = "Asia/Choibalsan";
    DateTimeZones["Asia/Macau"] = "Asia/Macau";
    DateTimeZones["America/Martinique"] = "America/Martinique";
    DateTimeZones["Europe/Malta"] = "Europe/Malta";
    DateTimeZones["Indian/Mauritius"] = "Indian/Mauritius";
    DateTimeZones["Indian/Maldives"] = "Indian/Maldives";
    DateTimeZones["America/Mexico_City"] = "America/Mexico_City";
    DateTimeZones["America/Cancun"] = "America/Cancun";
    DateTimeZones["America/Merida"] = "America/Merida";
    DateTimeZones["America/Monterrey"] = "America/Monterrey";
    DateTimeZones["America/Matamoros"] = "America/Matamoros";
    DateTimeZones["America/Mazatlan"] = "America/Mazatlan";
    DateTimeZones["America/Chihuahua"] = "America/Chihuahua";
    DateTimeZones["America/Ojinaga"] = "America/Ojinaga";
    DateTimeZones["America/Hermosillo"] = "America/Hermosillo";
    DateTimeZones["America/Tijuana"] = "America/Tijuana";
    DateTimeZones["America/Bahia_Banderas"] = "America/Bahia_Banderas";
    DateTimeZones["Asia/Kuala_Lumpur"] = "Asia/Kuala_Lumpur";
    DateTimeZones["Asia/Kuching"] = "Asia/Kuching";
    DateTimeZones["Africa/Maputo"] = "Africa/Maputo";
    DateTimeZones["Africa/Windhoek"] = "Africa/Windhoek";
    DateTimeZones["Pacific/Noumea"] = "Pacific/Noumea";
    DateTimeZones["Pacific/Norfolk"] = "Pacific/Norfolk";
    DateTimeZones["Africa/Lagos"] = "Africa/Lagos";
    DateTimeZones["America/Managua"] = "America/Managua";
    DateTimeZones["Europe/Amsterdam"] = "Europe/Amsterdam";
    DateTimeZones["Europe/Oslo"] = "Europe/Oslo";
    DateTimeZones["Asia/Kathmandu"] = "Asia/Kathmandu";
    DateTimeZones["Pacific/Nauru"] = "Pacific/Nauru";
    DateTimeZones["Pacific/Niue"] = "Pacific/Niue";
    DateTimeZones["Pacific/Auckland"] = "Pacific/Auckland";
    DateTimeZones["Pacific/Chatham"] = "Pacific/Chatham";
    DateTimeZones["America/Panama"] = "America/Panama";
    DateTimeZones["America/Lima"] = "America/Lima";
    DateTimeZones["Pacific/Tahiti"] = "Pacific/Tahiti";
    DateTimeZones["Pacific/Marquesas"] = "Pacific/Marquesas";
    DateTimeZones["Pacific/Gambier"] = "Pacific/Gambier";
    DateTimeZones["Pacific/Port_Moresby"] = "Pacific/Port_Moresby";
    DateTimeZones["Pacific/Bougainville"] = "Pacific/Bougainville";
    DateTimeZones["Asia/Manila"] = "Asia/Manila";
    DateTimeZones["Asia/Karachi"] = "Asia/Karachi";
    DateTimeZones["Europe/Warsaw"] = "Europe/Warsaw";
    DateTimeZones["America/Miquelon"] = "America/Miquelon";
    DateTimeZones["Pacific/Pitcairn"] = "Pacific/Pitcairn";
    DateTimeZones["America/Puerto_Rico"] = "America/Puerto_Rico";
    DateTimeZones["Asia/Gaza"] = "Asia/Gaza";
    DateTimeZones["Asia/Hebron"] = "Asia/Hebron";
    DateTimeZones["Europe/Lisbon"] = "Europe/Lisbon";
    DateTimeZones["Atlantic/Madeira"] = "Atlantic/Madeira";
    DateTimeZones["Atlantic/Azores"] = "Atlantic/Azores";
    DateTimeZones["Pacific/Palau"] = "Pacific/Palau";
    DateTimeZones["America/Asuncion"] = "America/Asuncion";
    DateTimeZones["Asia/Qatar"] = "Asia/Qatar";
    DateTimeZones["Indian/Reunion"] = "Indian/Reunion";
    DateTimeZones["Europe/Bucharest"] = "Europe/Bucharest";
    DateTimeZones["Europe/Belgrade"] = "Europe/Belgrade";
    DateTimeZones["Europe/Kaliningrad"] = "Europe/Kaliningrad";
    DateTimeZones["Europe/Moscow"] = "Europe/Moscow";
    DateTimeZones["Europe/Simferopol"] = "Europe/Simferopol";
    DateTimeZones["Europe/Kirov"] = "Europe/Kirov";
    DateTimeZones["Europe/Astrakhan"] = "Europe/Astrakhan";
    DateTimeZones["Europe/Volgograd"] = "Europe/Volgograd";
    DateTimeZones["Europe/Saratov"] = "Europe/Saratov";
    DateTimeZones["Europe/Ulyanovsk"] = "Europe/Ulyanovsk";
    DateTimeZones["Europe/Samara"] = "Europe/Samara";
    DateTimeZones["Asia/Yekaterinburg"] = "Asia/Yekaterinburg";
    DateTimeZones["Asia/Omsk"] = "Asia/Omsk";
    DateTimeZones["Asia/Novosibirsk"] = "Asia/Novosibirsk";
    DateTimeZones["Asia/Barnaul"] = "Asia/Barnaul";
    DateTimeZones["Asia/Tomsk"] = "Asia/Tomsk";
    DateTimeZones["Asia/Novokuznetsk"] = "Asia/Novokuznetsk";
    DateTimeZones["Asia/Krasnoyarsk"] = "Asia/Krasnoyarsk";
    DateTimeZones["Asia/Irkutsk"] = "Asia/Irkutsk";
    DateTimeZones["Asia/Chita"] = "Asia/Chita";
    DateTimeZones["Asia/Yakutsk"] = "Asia/Yakutsk";
    DateTimeZones["Asia/Khandyga"] = "Asia/Khandyga";
    DateTimeZones["Asia/Vladivostok"] = "Asia/Vladivostok";
    DateTimeZones["Asia/Ust-Nera"] = "Asia/Ust-Nera";
    DateTimeZones["Asia/Magadan"] = "Asia/Magadan";
    DateTimeZones["Asia/Sakhalin"] = "Asia/Sakhalin";
    DateTimeZones["Asia/Srednekolymsk"] = "Asia/Srednekolymsk";
    DateTimeZones["Asia/Kamchatka"] = "Asia/Kamchatka";
    DateTimeZones["Asia/Anadyr"] = "Asia/Anadyr";
    DateTimeZones["Asia/Riyadh"] = "Asia/Riyadh";
    DateTimeZones["Pacific/Guadalcanal"] = "Pacific/Guadalcanal";
    DateTimeZones["Indian/Mahe"] = "Indian/Mahe";
    DateTimeZones["Africa/Khartoum"] = "Africa/Khartoum";
    DateTimeZones["Europe/Stockholm"] = "Europe/Stockholm";
    DateTimeZones["Asia/Singapore"] = "Asia/Singapore";
    DateTimeZones["America/Paramaribo"] = "America/Paramaribo";
    DateTimeZones["Africa/Juba"] = "Africa/Juba";
    DateTimeZones["Africa/Sao_Tome"] = "Africa/Sao_Tome";
    DateTimeZones["America/El_Salvador"] = "America/El_Salvador";
    DateTimeZones["Asia/Damascus"] = "Asia/Damascus";
    DateTimeZones["America/Grand_Turk"] = "America/Grand_Turk";
    DateTimeZones["Africa/Ndjamena"] = "Africa/Ndjamena";
    DateTimeZones["Indian/Kerguelen"] = "Indian/Kerguelen";
    DateTimeZones["Asia/Bangkok"] = "Asia/Bangkok";
    DateTimeZones["Asia/Dushanbe"] = "Asia/Dushanbe";
    DateTimeZones["Pacific/Fakaofo"] = "Pacific/Fakaofo";
    DateTimeZones["Asia/Dili"] = "Asia/Dili";
    DateTimeZones["Asia/Ashgabat"] = "Asia/Ashgabat";
    DateTimeZones["Africa/Tunis"] = "Africa/Tunis";
    DateTimeZones["Pacific/Tongatapu"] = "Pacific/Tongatapu";
    DateTimeZones["Europe/Istanbul"] = "Europe/Istanbul";
    DateTimeZones["America/Port_of_Spain"] = "America/Port_of_Spain";
    DateTimeZones["Pacific/Funafuti"] = "Pacific/Funafuti";
    DateTimeZones["Asia/Taipei"] = "Asia/Taipei";
    DateTimeZones["Europe/Kiev"] = "Europe/Kiev";
    DateTimeZones["Europe/Uzhgorod"] = "Europe/Uzhgorod";
    DateTimeZones["Europe/Zaporozhye"] = "Europe/Zaporozhye";
    DateTimeZones["Pacific/Wake"] = "Pacific/Wake";
    DateTimeZones["America/New_York"] = "America/New_York";
    DateTimeZones["America/Detroit"] = "America/Detroit";
    DateTimeZones["America/Kentucky/Louisville"] = "America/Kentucky/Louisville";
    DateTimeZones["America/Kentucky/Monticello"] = "America/Kentucky/Monticello";
    DateTimeZones["America/Indiana/Indianapolis"] = "America/Indiana/Indianapolis";
    DateTimeZones["America/Indiana/Vincennes"] = "America/Indiana/Vincennes";
    DateTimeZones["America/Indiana/Winamac"] = "America/Indiana/Winamac";
    DateTimeZones["America/Indiana/Marengo"] = "America/Indiana/Marengo";
    DateTimeZones["America/Indiana/Petersburg"] = "America/Indiana/Petersburg";
    DateTimeZones["America/Indiana/Vevay"] = "America/Indiana/Vevay";
    DateTimeZones["America/Chicago"] = "America/Chicago";
    DateTimeZones["America/Indiana/Tell_City"] = "America/Indiana/Tell_City";
    DateTimeZones["America/Indiana/Knox"] = "America/Indiana/Knox";
    DateTimeZones["America/Menominee"] = "America/Menominee";
    DateTimeZones["America/North_Dakota/Center"] = "America/North_Dakota/Center";
    DateTimeZones["America/North_Dakota/New_Salem"] = "America/North_Dakota/New_Salem";
    DateTimeZones["America/North_Dakota/Beulah"] = "America/North_Dakota/Beulah";
    DateTimeZones["America/Denver"] = "America/Denver";
    DateTimeZones["America/Boise"] = "America/Boise";
    DateTimeZones["America/Phoenix"] = "America/Phoenix";
    DateTimeZones["America/Los_Angeles"] = "America/Los_Angeles";
    DateTimeZones["America/Anchorage"] = "America/Anchorage";
    DateTimeZones["America/Juneau"] = "America/Juneau";
    DateTimeZones["America/Sitka"] = "America/Sitka";
    DateTimeZones["America/Metlakatla"] = "America/Metlakatla";
    DateTimeZones["America/Yakutat"] = "America/Yakutat";
    DateTimeZones["America/Nome"] = "America/Nome";
    DateTimeZones["America/Adak"] = "America/Adak";
    DateTimeZones["Pacific/Honolulu"] = "Pacific/Honolulu";
    DateTimeZones["America/Montevideo"] = "America/Montevideo";
    DateTimeZones["Asia/Samarkand"] = "Asia/Samarkand";
    DateTimeZones["Asia/Tashkent"] = "Asia/Tashkent";
    DateTimeZones["America/Caracas"] = "America/Caracas";
    DateTimeZones["Asia/Ho_Chi_Minh"] = "Asia/Ho_Chi_Minh";
    DateTimeZones["Pacific/Efate"] = "Pacific/Efate";
    DateTimeZones["Pacific/Wallis"] = "Pacific/Wallis";
    DateTimeZones["Pacific/Apia"] = "Pacific/Apia";
    DateTimeZones["Africa/Johannesbur"] = "Africa/Johannesburg";
    DateTimeZones["UTC"] = "UTC";
})(DateTimeZones || (exports.DateTimeZones = DateTimeZones = {}));
/**
 * @deprecated please use "FrequencyPeriodType", as we're shifting away from enums
 */
var FrequencyPeriod;
(function (FrequencyPeriod) {
    FrequencyPeriod["Day"] = "day";
    FrequencyPeriod["Week"] = "week";
    FrequencyPeriod["Month"] = "month";
    FrequencyPeriod["Quarter"] = "quarter";
    FrequencyPeriod["Year"] = "year";
})(FrequencyPeriod || (exports.FrequencyPeriod = FrequencyPeriod = {}));
exports.FrequencyPeriodIterable = [
    'day',
    'week',
    'month',
    'quarter',
    'year',
];
var FrequencyType;
(function (FrequencyType) {
    FrequencyType["Rolling"] = "rolling";
    FrequencyType["Calendar"] = "calendar";
})(FrequencyType || (exports.FrequencyType = FrequencyType = {}));
exports.EncryptionTypeSchema = zod_1.z.enum(['gpg']);
exports.EncryptionConfigSchema = zod_1.z.object({
    privateKeySsmPath: zod_1.z.string(),
    encryptionType: exports.EncryptionTypeSchema,
    isEncryptedDataArmored: zod_1.z.boolean().optional(),
    passphraseSsmPath: zod_1.z.string().optional(),
});
exports.SftpConfigSchema = zod_1.z.object({
    authType: zod_1.z
        .enum(['password', 'privateKey'])
        .describe('Authentication type: password or privateKey'),
    host: zod_1.z.string().describe('SFTP host'),
    port: zod_1.z.number().optional().describe('SFTP port (optional)'),
    username: zod_1.z.string().describe('SFTP username'),
    ssmCredPath: zod_1.z.string().describe('SSM credential path'),
    rootPath: zod_1.z.string().optional().describe('Root path (optional)'),
});
//# sourceMappingURL=Utils.js.map